import React from "react";
import { useTranslation } from "react-i18next";
import { Badge } from "@shadcn-in-nx/ui/badge";
import { FileText, ExternalLink } from "lucide-react";

export default function KnowledgeBaseDocList({ docs }) {
    const { t } = useTranslation();

    if (!docs.length) {
        return (
            <div className="text-center py-6 text-muted-foreground text-sm">
                {t("admin.support.noDocs", "No documentation articles found")}
            </div>
        );
    }

    return (
        <div className="space-y-2">
            <div className="flex items-center gap-2">
                <h3 className="text-sm font-semibold">{t("admin.support.docArticles", "Documentation Articles")}</h3>
                <Badge variant="secondary">{docs.length}</Badge>
            </div>
            <div className="space-y-1">
                {docs.map((doc) => (
                    <a key={doc.id} href={doc.url} target="_blank" rel="noopener noreferrer"
                        className="flex items-center gap-3 p-3 border rounded-lg hover:bg-accent/50 transition-colors group">
                        <FileText className="w-4 h-4 text-blue-500 flex-shrink-0" />
                        <div className="flex-1 min-w-0">
                            <p className="text-sm font-medium truncate">{doc.title}</p>
                            {doc.description && (
                                <p className="text-xs text-muted-foreground truncate mt-0.5">{doc.description}</p>
                            )}
                        </div>
                        <ExternalLink className="w-3.5 h-3.5 text-muted-foreground opacity-0 group-hover:opacity-100 flex-shrink-0" />
                    </a>
                ))}
            </div>
        </div>
    );
}
